import { Loader } from 'components/shared/loader';
import { LoaderWrapper } from './page-loader.styles';

export const PageLoader = (): JSX.Element => (
  <LoaderWrapper>
    <Loader />
  </LoaderWrapper>
);
